import { Validators, FormBuilder } from '@angular/forms';

export let createDialogValidationMessages: {} = {
  chatType: {
    'required': 'Данное поле обязательно для заполнения.',
  },
  chatTheme: {
    'required': 'Данное поле обязательно для заполнения.',
    'maxlength': 'Длина ввода не может превышать 191 символ.',
    'pattern': 'В начале лишний пробел.',
  },
  chatMessage: {
    'required': 'Данное поле обязательно для заполнения.',
    'maxlength': 'Длина ввода не может превышать 191 символ.',
    'pattern': 'В начале лишний пробел.',
  },
  lawInstanceId: {
    'required': 'Данное поле обязательно для заполнения.',
    'maxlength': 'Длина ввода не может превышать 191 символ.',
  },
};

export function getCreateDialogControlsConfig(model, fb: FormBuilder) {
  return {
    chatType: [model.chatType, [Validators.required]],
    chatTheme: [model.chatTheme, [Validators.required, Validators.pattern(/^\S+/), Validators.maxLength(191)]],
    chatMessage: [model.chatMessage, [Validators.required, Validators.pattern(/^\S+/), Validators.maxLength(191)]],
    lawInstanceId: [{value: model.lawInstanceId, disabled: true}, [Validators.required, Validators.maxLength(191)]],
  };
}





// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/create-quest/create.dialog.form.ts